<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-2">
              <Button
                label="Nuevo"
                icon="pi pi-plus"
                class="p-button-success mr-2"
                @click="openNew"
              />
               
            </div>
          </template>

          <template v-slot:end>
            <Button
              label="Exportar"
              icon="pi pi-upload"
              class="p-button-help"
              @click="exportCSV($event)"
            />
          </template>
        </Toolbar>

        <DataTable
          ref="dt"
          :value="data"
          v-model:selection="selectedData"
          dataKey="id"
          :paginator="true"
          :rows="10"
          :filters="filters"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Solicitudes"
          responsiveLayout="scroll"
        >
          <template #header>
            <div
              class="
                flex flex-column
                md:flex-row md:justify-content-between md:align-items-center
              "
            >
              <h5 class="m-0">Solicitudes</h5>
              <span class="block mt-2 md:mt-0 p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global'].value"
                  placeholder="Buscar..."
                />
              </span>
            </div>
          </template>


        <Column
          field="id"
          header="#"
          :sortable="true"
          headerStyle="width:10%; min-width:4rem;"
          >
          <template #body="slotProps">
            <span class="p-column-title">#</span>
            {{ slotProps.data.id }}
          </template>
        </Column>

        <Column
          field="observations"
          header="Observaciones"
          :sortable="true"
          headerStyle="width:20%; min-width:10rem;"
          >
          <template #body="slotProps">
            <span class="p-column-title">Observaciones</span>
            {{ slotProps.data.observations }}
          </template>
        </Column>


        <Column
            field="status"
            header="Estatus"
            :sortable="true"
            headerStyle="width:20%; min-width:8rem;"
          >
            <template #body="slotProps">
              <span @click="showRejectReason(slotProps.data)" :class="'product-badge status-' + (slotProps.data.status ? slotProps.data.status.toLowerCase() : '')">
                  {{ slotProps.data.status }}
              </span> 
            </template>
        </Column>

        <Column
            field="user"
            header="Solicitado por"
            :sortable="true"
            headerStyle="width:30%; min-width:8rem;"
          >
            <template #body="slotProps">
            <span class="p-column-title">Solicitado por</span>
            {{ getApprovedUser(slotProps.data) }}
          </template>
        </Column>

        <Column
            field="approved_user"
            header="Aprobado por"
            :sortable="true"
            headerStyle="width:30%; min-width:8rem;"
          >
            <template #body="slotProps">
            <span class="p-column-title">Aprobado por</span>
            {{ getApprovedUser(slotProps.data, 'approved') }}
          </template>
        </Column>

        <Column
            field="date_at"
            header="Fecha"
            :sortable="true"
            headerStyle="width:50%; min-width:10rem;"
          >
            <template #body="slotProps">
              <span>
                  {{ slotProps.data.date_at }}
              </span> 
            </template>
        </Column>

          <Column 
            headerStyle="min-width:15rem;"
            field="action"
            header="Acción"
            :sortable="false"
            v-if="deposito"
          >
            <template #body="slotProps">
              <Button
                v-if="isPendingStatus(slotProps.data)"
                icon="pi pi-check"
                class="p-button-rounded p-button-info mr-2"
                @click="approveItem(slotProps.data)"
              />
              <Button
                icon="pi pi-times"
                class="p-button-rounded p-button-danger mr-2"
                @click="rejectItem(slotProps.data)"
                v-if="isPendingStatus(slotProps.data)"
              />
            </template>
          </Column>

              
          <Column headerStyle="min-width:10rem;">
            <template #body="slotProps"> 
              <Button
                icon="pi pi-eye"
                class="p-button-rounded p-button-warning mr-2"
                @click="showModal(slotProps.data)"
              />
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success mr-2"
                @click="editItem(slotProps.data)"
                v-if="isEditable(slotProps.data) && isOwn(slotProps.data)"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning mt-2"
                @click="confirmDeleteItem(slotProps.data)"
                v-if="isEditable(slotProps.data)"
              />
            </template>
          </Column>
            
        </DataTable>

        <Dialog
          v-model:visible="showDataDialog"
          :style="{ width: '450px' }"
          header="Insumos"
          :modal="true"
        >
          <div class="col-12">
              <p v-for="insumo of insumosfiltrados">
                  <b>
                    {{ insumo.quantity }}                     
                  </b>
                  -
                  {{ insumo.insumo.name }} <br><hr>
            </p>
          </div>
          <template #footer>
            <Button
              label="Cerrar"
              icon="pi pi-times"
              class="p-button-text"
              @click="showDataDialog = false"
            />            
          </template>
        </Dialog>

        <Dialog
          v-model:visible="itemDialog"
          :style="{ width: '450px' }"
          header="Solicitud de Insumos"
          :modal="true"
          class="p-fluid"
        >
          <div class="field">
            <label for="name">Observaciones </label>
            <InputText
              id="observations"
              v-model.trim="item.observations"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !item.observations }"
            />            
          </div>

          <div class="card">
            <div class="">
              <div class="formgrid grid">
                <div class="field col-6">
                  <label for="base">Insumos</label>
                  <AutoComplete
                    v-model="selectedInsumo"
                    :suggestions="filteredInsumo"
                    @complete="searchInsumo($event)"
                    field="name"
                    :dropdown="true"
                    @item-select="selectProduct(selectedInsumo)"
                    id="base"
                    class="inputfield w-full"
                  />
                </div>

                <div class="field col-6">
                  <label for="almacen_id">Depósito</label>
                  <Dropdown
                      id="almacen_id"
                      v-model="almacen_id"
                      :options="almacenes"
                      class="w-full"
                      optionLabel="name"
                      optionValue="id"
                      required="false"
                      @change="selectAlmacen()"
                      autofocus
                  />
                  
                </div>

                <div class="field col-6">
                  <label for="base">Cantidad</label>
                  <InputText
                    id="quantity"
                    v-model.trim="quantity"
                    autofocus
                    :disabled="!newItemInsumo && ! almacen_id"
                  />    
                </div>

              <div class="field col-4">        
                <Button :disabled="!newItemInsumo && !almacen_id && quantity <= 0"  @click="addItemDetalle(newItemInsumo)" label="Agregar" 
                  icon="pi pi-plus" class="p-button-success inputfield w-full mt-5" />
              </div>
            </div>

            <DataTable
              :value="detalle"
              dataKey="id" 
              class="p-datatable-sm"
              responsiveLayout="scroll"
            >
              <Column field="id" header="" >
                <template #body="slotProps">
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger" @click="delItemInsumo(slotProps.data.id)"></Button>
                </template>
              </Column>
              <Column field="name" header="Insumo">
              <template #body="slotProps">
                <b>
                  {{ slotProps.data.name }}
                </b>
                </template>
              </Column>

              <Column field="name" header="Cantidad">
              <template #body="slotProps">
                <b>
                  {{ slotProps.data.quantity }}
                </b>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
          

          <template #footer>
            <Button
              label="Cancelar"
              icon="pi pi-times"
              class="p-button-text"
              @click="hideDialog"
            />
            <Button
              label="Guardar"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveItem"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteItemDialog"
          :style="{ width: '450px' }"
          header="Confirmación"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="item">                
                <div class="field">
                  <label for="name">Motivo de rechazo (Solicitud # <b>{{ item.id }}</b>) </label>
                  <InputText
                    id="reject_reason"
                    v-model.trim="item.reject_reason"
                    required="true"
                    autofocus
                    class="w-100"
                  />            
                </div>
              </span>


          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteItemDialog = false"
            />
            <Button
              label="Sí"
              icon="pi pi-check"
              class="p-button-text"              
              @click="sendRejectItem(item)"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteDataDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="item">Seguro?</span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteDataDialog = false"
            />
            <Button
              label="Sí"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedData"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import CrudService from "../services/crud.service";
import UserService from "../services/user.service";

export default {
  data() {
    return {
      routeName: null,
      data: [{id:null, oti_id:null, observations:'', status: '', date_at: null}],
      itemDialog: false,
      deleteItemDialog: false,
      deleteDataDialog: false,
      item: {id:null, oti_id:null, observations:'',  status:'', reject_reason:'' },
      selectedData: null,
      filters: {},
      submitted: false,
      validationErrors: null,
      otis: [],
      detalle: [],
      insumos: [],
      newItemInsumo: null,
      quantity: 0,
      filteredInsumo: null,
      selectedInsumo : null,
      deposito: null,
      almacenes: [],
      almacen_id: null,
      insumosfiltrados: [],
      showDataDialog: false
    };
  },
  created() {
    this.routeName = this.$route.name;
     
    this.initFilters();
  },
  mounted() {
    CrudService.getCRUD('insumos', 'insumo').then((data) => (this.insumos = data));
    CrudService.getCRUD('almacenes').then((data) => (this.almacenes = data));
    CrudService.getCRUD(this.routeName).then(
      (data) => {
        data.forEach((item) => {
          item.date_at = this.formatDate(item.created_at);
        });

        this.data = data;
        if (data.detalle) {
          data.detalle.forEach((item) => {
            let obj = {
              id: item?.insumo.id,
              name: item?.insumo.name,
              quantity: item?.quantity
            };
            this.detalle.push(obj);
          });
        }
      }
    );
    UserService.getUserBoard().then(
      (response) => {
        this.userData = response.data;
        if (this.userData) {
            let deposito = this.userData.roles.filter((item) => item.name == 'gerencia' || item.name == 'planta' || item.name == 'deposito');
            if (deposito.length > 0) {
                this.deposito = 1;
            }
        }
      });
  },
  methods: { 
    showModal (data) {
      this.insumosfiltrados = data.detalle;
      this.showDataDialog = true;
    },
    getApprovedUser(user, mode = null) {
      let name = '';
      if (mode == 'approved' && user.approved_user && user.approved_user.name) {
        name += user.approved_user.last_name && user.approved_user.last_name != null ? user.approved_user.last_name : '';
        return name + ' ' + user.approved_user.name;      
      }
      if (mode == null && user.user && user.user.name) {
        name += user.user.last_name && user.user.last_name != null ? user.user.last_name : '';
        return name + ' ' + user.user.name;
      }
      return '';
    },
    formatDate(date_at) {
      return new Date(date_at).toLocaleString(); //date_at;
    },
    selectProduct(selectedInsumo) {
      this.newItemInsumo = selectedInsumo;
      this.quantity = 0;
      if (this.almacen_id) {
        let data = this.newItemInsumo.almacenes_insumos.filter((item) => item.almacen_id == this.almacen_id  );
        if (data && data.length) {
          this.quantity = data[0].stock;
        }
      }
    },
    selectAlmacen() {
      this.quantity = 0;
      if (this.newItemInsumo) {
        let data = this.newItemInsumo.almacenes_insumos.filter((item) => item.almacen_id == this.almacen_id );
        if (data && data.length) {
          this.quantity = data[0].stock;
        }
      }
    },
    delItemInsumo(itemId) {
      let index = this.detalle.findIndex(item => item.id == itemId);
      this.detalle.splice(index, 1);
    }, 
    searchInsumo(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredInsumo = [...this.insumos];
        } else {
          this.filteredInsumo = this.insumos.filter((insumo) => {
            return insumo.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      }, 250);
    },
    addItemDetalle() {
      if (this.quantity <= 0) {
        this.$toast.add({
                severity: "error",
                summary: "Error!",
                detail: "Debe ingresar la cantidad.",
                life: 3000,
              });
        return false;
      }
      if (! this.newItemInsumo) {
        this.$toast.add({
                severity: "error",
                summary: "Error!",
                detail: "Debe seleccionar el insumo a agregar.",
                life: 3000,
              });
        return false;
      }
      if (parseInt(this.quantity) > parseInt(this.newItemInsumo.quantity)) {
        this.$toast.add({
                severity: "error",
                summary: "Atención!",
                detail: "La Cantidad solicitada es superior al Stock actual!",
                life: 3000,
              });
      }
      
      this.detalle.push({
        id: this.newItemInsumo.id,
        name: this.newItemInsumo.name,
        quantity: this.quantity,
        almacen_id: this.almacen_id,
      });
      this.actualFormulaUser = null;
      this.newItemInsumo = null;
      this.selectedInsumo = null;
      this.almacen_id = null;
      this.quantity = 0;
    },
    openNew() {
      this.item = {};
      this.detalle = [];
      
      this.submitted = false;
      this.itemDialog = true;
    },
    hideDialog() {
      this.itemDialog = false;
      this.submitted = false;
    },
    displayErrors(errors) {      
              for (let key in errors) {
                this.validationErrors.push({ "field": key, "message": errors[key] });
                let error = errors[key];
                this.$toast.add({
                  severity: "error",
                  summary: "Error!",
                  detail: error[0],
                  life: 3000,
                });
              }
    },
    requestUpdate(url=null) {
      let routeName = this.routeName;
      let updateValue = null;
      if (url) {
        routeName = url;
        updateValue = true;
      }
      CrudService.updateCRUD(routeName, routeName, this.item).then((response) => {        
        if (response.status == 400) { 
          this.displayErrors(response.data);
          return false;
        } 
        this.$toast.add({
          severity: "success",
          summary: "Éxito!",
          detail: "Actualizado correctamente.",
          life: 3000,
        });
        this.data[this.findIndexById(this.item.id)] = this.item;
        if (updateValue) {
          this.data[this.findIndexById(this.item.id)] = response.data;
        }
        this.data[this.findIndexById(this.item.id)].detalle = [];
        
        response.data.detalle.forEach((item) => {
          this.data[this.findIndexById(this.item.id)].detalle.push(item);                
        });
        
        this.initFields();
      });
    },
    requestCreate() {
      CrudService.createCRUD(this.routeName, this.routeName, this.item).then((response) => {              
        if (response.status == 400) { 
          this.displayErrors(response.data);              
          return false;
        }
        //this.data.push(response.data);

        const newElement = response.data;
        const newArray = [...this.data];
        newArray.unshift(newElement);
        this.data = newArray;

        this.$toast.add({
          severity: "success",
          summary: "Éxito!",
          detail: "Creado correctamente.",
          life: 3000,
        });
        this.initFields();
      });
    },
    saveItem() {
      this.submitted = true;
      
      if (! this.detalle) {
        this.$toast.add({
          severity: "danger",
          summary: "Atención!",
          detail: "Debe ingresar los insumos a solicitar.",
          life: 3000,
        });
      }
      this.validationErrors = [];
      this.item.details = this.detalle;
      if (this.item.id) {
        this.requestUpdate();
        return false;
      } 

      this.requestCreate();
    },
    approveItem(item) {
      this.submitted = true;
      
      this.validationErrors = [];
      this.item = item;
      this.requestUpdate('aprobar-solicitud');
    },
    showRejectReason(item) {
      if (item.reject_reason != null && item.reject_reason != '') {
        this.$toast.add({
            severity: "info",
            summary: "Motivo del Rechazo",
            detail: item.reject_reason,
            life: 3000,
          });
      }
    },
    rejectItem(item) {
      /*
      this.submitted = true;
      
      this.validationErrors = [];
      this.item = item;
      this.requestUpdate('rechazar-solicitud');
      */
      this.item = item;
      this.deleteItemDialog = true;
    },
    sendRejectItem(item) {
      this.submitted = true;
      
      this.validationErrors = [];
      this.item = item;
      if (item.reject_reason && item.reject_reason!=null && item.reject_reason!='') {
        this.requestUpdate('rechazar-solicitud');
        this.deleteItemDialog = false;        
      } else {

      }
    },
    initFields() {
      this.itemDialog = false;
      this.item = {};
      this.detalle = [];
    },
    isPendingStatus(item) {      
      return item.status == 'PENDIENTE';
    },
    isEditable(item) {      
      return item.is_editable;
    },
    isOwn(item) {      
      return item.is_own;
    },
    editItem(item) {
      this.detalle = [];
      this.item = { ...item };
      this.item.detalle.forEach((item) => {
        let obj = {
          quantity: item?.quantity,
          name: item?.insumo.name,
          id: item?.insumo.id
        };
        this.detalle.push(obj);
      });
      this.itemDialog = true;
    },
    confirmDeleteItem(item) {
      this.item = item;
      this.deleteItemDialog = true;
    },
    deleteItem() {
      CrudService.deleteCRUD(this.routeName, this.routeName, this.item.id).then(
        (response) => {
          //this.data.splice(this.findIndexById(data.data.id), 1);
          this.data = this.data.filter((item) => item.id != response.data);
          this.item = {};
          this.$toast.add({
            severity: "success",
            summary: "Éxito!",
            detail: "Eliminado correctamente.",
            life: 3000,
          });         
        }
      );
      this.deleteItemDialog = false;
      this.item = {};
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id == id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteDataDialog = true;
    },
    deleteSelectedData() {
      this.data = this.data.filter(
        (val) => !this.selectedData.includes(val)
      );
      this.deleteDataDialog = false;
      this.selectedData = null;
      this.$toast.add({
        severity: "success",
        summary: "Éxito!",
        detail: "Eliminado correctamente.",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/demo/badges.scss";

.product-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.product-badge.status-aprobado {
    background: #c8e6c9;
    color: #256029;
}

.product-badge.status-pendiente {
    background: #feedaf;
    color: #8a5340;
}

.product-badge.status-rechazado {
    background: #ffcdd2;
    color: #c63737;
}
</style>
